import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { Group, Image as ImageLayer } from "ol/layer";

export const baseLayers = new Group({
  title: "Mapas base",
  fold: "close",
  layers: [
    new TileLayer({
      title: "IGN",
      type: "base",
      visible: true,
      source: new OSM({
        url: "https://wms.ign.gob.ar/geoserver/gwc/service/tms/1.0.0/capabaseargenmap@EPSG%3A3857@png/{z}/{x}/{-y}.png",
        attributions:
          '<a href="https://www.ign.gob.ar/" target="_blank">Instituto Geográfico Nacional </a>',
      }),
    }),
    new TileLayer({
      title: "IGN - Topográfico",
      type: "base",
      visible: false,
      source: new OSM({
        url: "https://wms.ign.gob.ar/geoserver/gwc/service/tms/1.0.0/mapabase_topo@EPSG%3A3857@png/{z}/{x}/{-y}.png",
        attributions:
          '<a href="https://www.ign.gob.ar/" target="_blank">Instituto Geográfico Nacional </a>',
      }),
    }),
    new TileLayer({
      title: "IGN - Gris",
      type: "base",
      visible: false,
      source: new OSM({
        url: "https://wms.ign.gob.ar/geoserver/gwc/service/tms/1.0.0/mapabase_gris@EPSG%3A3857@png/{z}/{x}/{-y}.png",
        attributions:
          '<a href="https://www.ign.gob.ar/" target="_blank">Instituto Geográfico Nacional </a>',
      }),
    }),

    new TileLayer({
      title: "GOOGLE SATÉLITE",
      type: "base",
      visible: false,
      source: new OSM({
        url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        attributions: "GOOGLE SATÉLITE",
      }),
    }),
    new TileLayer({
      title: "OSM",
      type: "base",
      visible: false,
      source: new OSM(),
    }),
    new TileLayer({
      title: "Blanco - Sin capa base",
      type: "base",
      visible: false,
      source: new OSM({
        url: "",
      }),
    }),
  ],
});
